export default {
    name: 'FormGroupCheck',
    props: {
        label: String,
        labelclass: {
            type: String,
            default: ''
        },
        groupclass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        };
    },
};